import { Grid, Typography } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import { AdminRoleId } from '@tassat/common-definitions';
import { UserRecord } from '@tassat/fred-definitions';
import { AdminUserRecordMapped } from '@tassat/fred-extended-definitions';
import React from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

import UserAuthActions from './userAuthActions';

interface UserDetailsProps extends WithStyles<typeof muiStyles>{
    currentUser: UserRecord;
    user: AdminUserRecordMapped | UserRecord;
}

const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        padding: '0 1rem',
        marginTop: '1.5rem'
    },
    userDetailsContainer: { paddingBottom: '2.5rem' },
    label: { paddingBottom: '.75rem' },
    largeText: { fontSize: '1.2rem' },
    acgNumber: {
        backgroundColor: theme?.app?.applicationColors.detailTagBackground ||
            '#E4EFFA',
        borderRadius: '6px',
        padding: '.2rem .4rem',
        marginRight: '.5rem',
        marginBottom: '.5rem',
        fontSize: '.9rem'
    },
    notesContainer: { whiteSpace: 'normal' as const },
    notes: { wordBreak: 'break-word' as const },
    noNotes: {
        color: theme?.app?.applicationColors.enumColors.greyLighter ||
            '#cfcfcf'
    },
    actionButtonsContainer: { marginTop: '2rem' },
    actionButton: { marginRight: '1rem' },
    asset: { margin: '.2rem' }
});

export function UserDetails (props: UserDetailsProps) {
    const {
        classes,
        currentUser,
        user
    } = props;

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            <Grid
                className={classes.userDetailsContainer}
                container
                direction='row'
                justifyContent='space-between'
                spacing={0}
                wrap='nowrap'
            >
                <Grid
                    container
                    direction='column'
                    item
                    spacing={0}
                    xs={4}
                >
                    <Typography
                        className={classes.label}
                        variant='body2'
                    >Role
                    </Typography>
                    <Typography
                        className={classes.largeText}
                        id='userDetailsUserRoleValue'
                        variant='body1'
                    >{(user as AdminUserRecordMapped).UserRoleDisplay}
                    </Typography>
                </Grid>
                {user.AdminRoleId === AdminRoleId.PCG_ADMIN &&
                    <Grid
                        container
                        direction='column'
                        item
                        spacing={0}
                        xs={4}
                    >
                        <Typography
                            className={classes.label}
                            variant='body2'
                        >ACG Mapping
                        </Typography>
                        <Grid
                            container
                            direction='row'
                            spacing={0}
                        >
                            {('AcgMapping' in user) && user.AcgMapping?.map(acg => {
                            return (
                                <Typography
                                    className={classes.acgNumber}
                                    id='uetailsUserAcgValues'
                                    key={acg.ACGId}
                                    variant='body1'
                                >{acg.ACGNumber?.toUpperCase()}
                                </Typography>
                            );
                        })}
                        </Grid>
                    </Grid>}
                <Grid
                    className={classes.notesContainer}
                    container
                    direction='column'
                    item
                    spacing={0}
                    xs={4}
                >
                    <Typography
                        className={classes.label}
                        variant='body2'
                    >Notes
                    </Typography>
                    <Typography
                        className={user.Notes ? classes.notes : classes.noNotes}
                        id='userDetailsUserNotesValue'
                        variant='body1'
                    >{user.Notes || 'No notes'}
                    </Typography>
                </Grid>
            </Grid>
            {currentUser.UserId !== user.UserId &&
                <Grid
                    className={classes.userDetailsContainer}
                    container
                    direction='row'
                    justifyContent='space-between'
                    spacing={0}
                    wrap='nowrap'
                >
                    <UserAuthActions
                        user={user}
                    />
                </Grid>}
        </Grid>
    );
}

export default withStyles(muiStyles)(UserDetails);